<template>
  <div class="d-requests">
    <h3 class="h3 mt0">Reviewer Requests</h3>
    <p class="p">Here you can approve or refuse dentists requests to become a VeriTooth Reviewer </p>
    <module-spinner
      :active="loading"
      :floating="true"
    />

    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="reviewerRequestsLength > 0"

        key="requests-table"
      >
        <module-table
          :columns="columns"
          :rows="reviewerRequests.results"
          :row-click="true"

          @row-click="onRowClick"
        />

        <div class="d-requests__more">
          <p class="p">Showing <strong>{{ reviewerRequestsLength }}</strong> of <strong>{{ reviewerRequestsTotal }}</strong> Results</p>
          <module-button
            v-if="reviewerRequests.next"

            button="primary"
            label="Load more"
            :loading="loading"
          />
        </div>
      </div>
      <p v-else-if="reviewerRequestsLength === 0 && !loading" class="fw-bold mt2">No current requests</p>
    </transition>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex';

// Models
import { statusMap } from 'models/reviewer';

// Modules
import ModuleDetailList from 'modules/DetailList';
import ModuleButton from 'modules/Button';
import ModuleSpinner from 'modules/Spinner';
import ModuleTable from 'modules/Table';

// Export
export default {
  name: `ui-dashboard-reviewer-requests`,

  // Components
  components: {
    ModuleDetailList,
    ModuleButton,
    ModuleSpinner,
    ModuleTable,
  },

  // Data
  data() {
    return {
      loading: true,
    };
  },

  // Computed
  computed: {
    ...mapGetters(`reviewer`, [
      `reviewerRequests`,
      `reviewerRequestsLength`,
      `reviewerRequestsTotal`,
    ]),
    columns() {
      return [
        {
          heading: `Status`,
          value: request => statusMap[request.status],
        },
        {
          heading: `Name`,
          value: request => `Dr ${request.doctor.last_name}`,
        },
        {
          heading: `Address`,
          value: request => request.doctor.clinics.length ? request.doctor.clinics[0].city : ``,
        },
        {
          heading: `ID`,
          value: request => request.doctor.profile.license_number,
        },
        {
          heading: `Link`,
          hidden: true,
          align: `right`,
          value: () => ({
            is: ModuleButton,
            bind: {
              label: `View Request`,
              button: `primary`,
              size: `s`,
              icon: `arrow-right`,
            },
          }),
        },
      ];
    },
  },

  // Methods
  methods: {
    ...mapActions(`reviewer`, [
      `getReviewerRequests`,
    ]),
    onRowClick(id) {
      this.$router.push({
        name: `admin-reviewer-request`,
        params: {
          id,
        },
      });
    },
  },

  // Lifecycle
  created() {
    this.getReviewerRequests()
      .then(() => this.loading = false);
  },
};
</script>



// WEBPACK FOOTER //
// ReviewerRequests.vue?0f50c254